import { Clock } from "lucide-react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { SettingCard } from "@/components/settings/setting-card";
import { SettingField } from "@/components/settings/setting-field";
import { FormControl, FormField, FormItem } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import type { SaveField } from "../../../hooks/use-auto-save-field";
import type { BookingBehaviorFormData } from "../types";

interface AutoBookingSettingsProps {
  saveField: SaveField<BookingBehaviorFormData>;
  savingFields: Set<keyof BookingBehaviorFormData>;
}

export function AutoBookingSettings({ saveField, savingFields }: AutoBookingSettingsProps) {
  const form = useFormContext<BookingBehaviorFormData>();
  const { t } = useTranslation("settings");

  return (
    <div className="space-y-6">
      {/* Worker Assignment */}
      {/* <SettingCard */}
      {/*   title={t("bookingBehavior.workerAssignment")} */}
      {/*   icon={<Users className="w-5 h-5 text-green-600 dark:text-green-400" />} */}
      {/*   helpText={t("bookingBehavior.workerAssignmentDescription")} */}
      {/*   helpDetails={ */}
      {/*     <div className="space-y-2"> */}
      {/*       <div className="text-sm font-medium text-foreground"> */}
      {/*         {t("bookingBehavior.autoModeBenefits")} */}
      {/*       </div> */}
      {/*       <ul className="text-sm space-y-1 text-muted-foreground"> */}
      {/*         <li>• {t("bookingBehavior.instantBooking")}</li> */}
      {/*         <li>• {t("bookingBehavior.alwaysAvailable")}</li> */}
      {/*         <li>• {t("bookingBehavior.streamlinedAssignment")}</li> */}
      {/*         <li>• {t("bookingBehavior.reducedWorkload")}</li> */}
      {/*       </ul> */}
      {/*     </div> */}
      {/*   } */}
      {/* > */}
      {/*   <div className="space-y-4"> */}
      {/*     {env.flags.showExperimental && ( */}
      {/*       <FormField */}
      {/*         control={form.control} */}
      {/*         name="autoArrangeWorkers" */}
      {/*         render={({ field }) => ( */}
      {/*           <FormItem> */}
      {/*             <FormControl> */}
      {/*               <Switch */}
      {/*                 checked={field.value} */}
      {/*                 onCheckedChange={field.onChange} */}
      {/*                 disabled={saving} */}
      {/*               /> */}
      {/*             </FormControl> */}
      {/*           </FormItem> */}
      {/*         )} */}
      {/*       /> */}
      {/*     )} */}
      {/*   </div> */}
      {/* </SettingCard> */}

      {/* Confirmation Settings */}
      <SettingCard
        title={t("bookingBehavior.confirmationSettings")}
        icon={<Clock className="w-5 h-5 mr-0.5 text-green-600 dark:text-green-400" />}
        helpText={t("bookingBehavior.confirmationSettingsDescription")}
      >
        <div className="space-y-6">
          <FormField
            control={form.control}
            name="autoConfirmImmediately"
            render={({ field }) => (
              <FormItem id="field-booking-auto-confirm">
                <SettingField
                  label={t("bookingBehavior.confirmImmediately")}
                  helpText={t("bookingBehavior.confirmImmediatelyDescription")}
                >
                  <FormControl>
                    <Switch
                      checked={field.value}
                      onCheckedChange={(value) => {
                        void saveField("autoConfirmImmediately", value);
                      }}
                      disabled={savingFields.has("autoConfirmImmediately")}
                    />
                  </FormControl>
                </SettingField>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="autoBatchConfirmInterval"
            render={({ field }) => (
              <FormItem id="field-booking-auto-batch-interval">
                <SettingField
                  label={t("bookingBehavior.batchConfirmationInterval")}
                  helpText={t("bookingBehavior.batchConfirmationIntervalDescription")}
                >
                  <FormControl>
                    <div className="flex items-center space-x-2">
                      <Input
                        type="number"
                        min={1}
                        max={60}
                        step={1}
                        className="w-32"
                        {...field}
                        onChange={(e) => field.onChange(Number(e.target.value))}
                      />
                      <span className="text-sm text-muted-foreground">
                        {t("bookingBehavior.minutes")}
                      </span>
                    </div>
                  </FormControl>
                </SettingField>
              </FormItem>
            )}
          />
        </div>
      </SettingCard>
    </div>
  );
}
